<template>
	<div class="page-container">
		<head-top head-title="个人信息" goBack="true"></head-top>

		<div class="settings-page">
			<div class="section-card bg_a">
					
				<div class="flex_c section-cell">
					<div>邮箱账号</div>
					<div class="right-cell flex_a">
						<div>{{ profile.account }}</div>
					</div>
				</div>
				
				<div class="flex_c section-cell">
					<div>注册时间</div>
					<div class="right-cell flex_a">
						<div>{{ profile.createTime }}</div>
					</div>
				</div>

				<div class="flex_c section-cell">
					<div>修改登录密码</div>
					<div class="right-cell flex_a" @click="handleChangePwd">
						<van-icon name="arrow" class="cell-arrow" />
					</div>
				</div>
			</div>

			<div class="logout-btn bg_a" @click="handleLogout">退出登录</div>
		</div>

	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import {
		logoutMember,
		getMineData,
		getLoginMember
	} from '@/apis/api.js'

	export default {
		name: 'Settings',
		components: {
			headTop: headTop
		},
		data() {
			return {
				profile: {},
			}
		},
		mounted() {
			this.checkLoginAndLoad()
		},
		methods: {
			checkLoginAndLoad() {
				if (!getLoginMember()) {
					this.$router.push('/login?redirect=' + encodeURIComponent(this.$route.fullPath))
					return
				}
				this.loadData()
			},
			loadData() {
				this.$toast.loading({ message: '加载中...', duration: 0 })
				getMineData()
					.then(res => {
						this.profile = res
					})
					.catch(e => {
						if (e.handled) return
						this.$toast(e.msg || '加载失败')
					})
					.finally(() => {
						this.$toast.clear()
					})
			},
			handleChangePwd(){
				this.$router.push('/forgot_password')
			},
			handleLogout() {
				this.$dialog.confirm({
					title: '退出登录',
					message: '确定要退出登录吗？',
					confirmButtonColor: '#e33737'
				})
					.then(() => {
						logoutMember()
						this.$router.go(-1)
					})
					.catch(() => {})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page-container {
		padding-top: 48px;

		.settings-page {
			padding: 14px;

			.section-card {
				border-radius: 8px;
				overflow: hidden;

				.section-cell {
					padding: 14px;
					border-bottom: 1px solid #e4e7ed;
					font-size: 15px;
					color: #333;

					.right-cell {
						font-size: 15px;
						color: #999;
						flex: 1;
						justify-content: flex-end !important;

						.avatar-upload {

							.avatar-img {
								width: 50px;
								height: 50px;
								border-radius: 50%;
								object-fit: cover;
							}
						}

						.cell-arrow {
							margin-left: 10px;
							font-size: 16px;
							color: #999;
						}

						.invite-text {
							color: #e33737;
						}
					}
				}
			}

			.logout-btn {
				text-align: center;
				margin-top: 14px;
				border-radius: 8px;
				width: 100%;
				height: 50px;
				line-height: 50px;
				color: #e33737;
				font-size: 15px;
				cursor: pointer;
			}
		}

		.pwd-panel {
			width: 90vw;
			max-width: 400px;
			background: #fff;
			border-radius: 8px;
			overflow: hidden;

			.pwd-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 17px 14px 10px;
				border-bottom: 1px solid #f0f0f0;

				.pwd-title {
					color: #222;
					font-size: 17px;
					font-weight: 800;
				}

				.pwd-close {
					font-size: 24px;
					color: #999;
					cursor: pointer;
				}
			}

			.pwd-body {
				padding: 14px;

				.pwd-field {
					margin-bottom: 12px;

					.pwd-label {
						display: block;
						margin-bottom: 6px;
						color: #555;
						font-size: 13px;
					}

					.pwd-input {
						width: 100%;
						height: 39px;
						padding: 0 11px;
						color: #222;
						background: #f6f6f6;
						border-radius: 4px;
						font-size: 14px;
						box-sizing: border-box;
					}
				}
			}

			.pwd-actions {
				display: flex;
				gap: 9px;
				padding: 10px 14px 14px;
				border-top: 1px solid #f0f0f0;

				.pwd-cancel,
				.pwd-submit {
					flex: 1;
					height: 41px;
					line-height: 41px;
					text-align: center;
					border-radius: 21px;
					font-size: 15px;
					border: none;
					cursor: pointer;
				}

				.pwd-cancel {
					color: #555;
					background: #eee;
				}

				.pwd-submit {
					color: #fff;
					background: #e33737;
				}
			}
		}
	}
</style>